<template>
  <div class="my-confirm-plaugin-box" v-show="dialogVisible">
    <div class="confirm-plaugin-box">
      <div class="confirm-title">
        <div>{{msg.title}}</div>
        <div @click="close()"><img src="@/assets/img/confirmPlaugin/close.png" alt=""></div>
      </div>
      <div class="comfirm-content">
        <img v-if="type == 'success'" src="@/assets/img/toast/icon_success.png" alt="">
        <img v-if="type == 'error'" src="@/assets/img/toast/zhuyi.png" alt="">
        <span>
          {{msg.content}}
        </span>
        <div class="comfirm-btn">
          <Button3 v-if="buttonClose != ''" @click="close(false)">{{buttonClose}}</Button3>
          <Button1 @click="close(true)">{{buttonSubmit}}</Button1>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

//  <!-- success error -->

// let data = {
//   type: 'error',
//   buttonSubmit: '确认',
//   buttonClose: '取消',
//   msg: {
//     title: '提示',
//     content: '成功'
//   },
// }
// this.$_popout1(data)
export default {
  name: 'ConfirmPlaugin1',
  props: {

  },
  data () {
    return {
      type: 'error',
      buttonSubmit: '确认',
      buttonClose: '',
      msg: {
        title: '温馨提示',
        content: '成功'
      },
      dialogVisible: true,
      callBack: function () {

      },
      closeCallBack: function () {

      }
    }
  },
  methods: {
    close (bol) {
      this.dialogVisible = false
      if (bol) {
        this.callBack()
      }
      if (bol === false) {
        this.closeCallBack()
      }
      this.$destroy(true)
      this.$el.parentNode.removeChild(this.$el)
    }
  },
  mounted () {},
  destroyed () {
    if (this.dialogVisible) {
      this.$destroy(true)
      this.$el.parentNode.removeChild(this.$el)
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
//
  .my-confirm-plaugin-box{
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, .5);
    z-index: 99;
    .confirm-plaugin-box{
      width: 600px;
      margin: 10% auto;
      height: auto;
      /*min-height: 300px;*/
      background-color: #ffffff;
      border-radius: 4px;
      border:1px solid rgba(228, 231, 237, 1);
      box-shadow:0 3px 10px 0 rgba(0, 0, 0, 0.08);
      .confirm-title{
        font-size: 18px;
        border-bottom: 1px solid #E4E7ED;
        height: 60px;
        line-height: 60px;
        // padding: 0 20px 0 15px;
        position: relative;
        >div{
          position: absolute;
          &:nth-child(1){
            left: 0;
            text-indent: 15px;
            top: 0;
          }
          &:nth-child(2){
            right: 0;
            top: 0;
            padding: 0 15px;
            cursor: pointer;
          }
        }
      }
      .comfirm-content{
        width: 70%;
        margin: 0 auto;
        text-align: center;
        padding: 30px 0 40px 0;
        img{
          display: block;
          margin: 0 auto 20px;
        }
        span{
          color: #969696;
          font-size: 16px;
        }
        .comfirm-btn{
          margin-top: 40px;
          >button{
            &:nth-child(2){
              margin-left: 20px;
            }
          }
        }
      }
    }
  }
</style>
